export const selectRegions = (state) => state.region.list;
export const selectRegionLoading = (state) => state.region.loading;
export const selectCreateRegionLoading = (state) => state.region.createLoading;
export const selectUpdateRegionLoading = (state) => state.region.updateLoading;
export const selectDeleteRegionLoading = (state) => state.region.deleteLoading;
export const selectRegionError = (state) => state.region.error;
export const selectRegionSuccess = (state) => state.region.success;
